const terms = [
  "Users are responsible for the accuracy of account details, destination wallets, and payout instructions submitted on the platform.",
  "MekPay may apply transaction reviews, KYC checks, account limits, or temporary holds where risk, compliance, or fraud signals require additional verification.",
  "Crypto transactions can be irreversible once broadcast on-chain. Users must verify wallet addresses, network selections, and asset types before submission.",
  "Bank transfer and bill settlement timings may vary based on partner rails, internal review workflows, and external provider availability.",
  "Suspicious, abusive, fraudulent, or unlawful use may result in account restriction, transaction cancellation where possible, and regulatory reporting where required.",
  "By using MekPay, you agree to follow these terms and any additional policies communicated through the platform.",
];

export default function TermsPage() {
  return (
    <section className="bg-slate-950 py-16 text-white md:py-24">
      <div className="mx-auto max-w-4xl px-6">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.25em] text-cyan-300">
          Terms
        </p>
        <h1 className="text-4xl font-bold md:text-5xl">
          Terms of service.
        </h1>
        <p className="mt-5 text-lg leading-8 text-slate-300">
          These terms explain platform usage rules, transaction responsibilities, and account expectations when using MekPay.
        </p>

        <div className="mt-12 space-y-4">
          {terms.map((term) => (
            <div key={term} className="rounded-3xl border border-white/10 bg-white/5 p-6 text-base leading-7 text-slate-200">
              {term}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}